/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import Person from './Person';

/**
 * The ShareLinkRequest model module.
 * @module model/ShareLinkRequest
 * @version v0
 */
export default class ShareLinkRequest {
  /**
   * Constructs a new <code>ShareLinkRequest</code>.
   * @alias module:model/ShareLinkRequest
   * @class
   * @param to {String} 
   * @param urlLink {String} 
   */
  constructor(to, urlLink) {
    this.to = to;
    this.urlLink = urlLink;
  }

  /**
   * Constructs a <code>ShareLinkRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ShareLinkRequest} obj Optional instance to populate.
   * @return {module:model/ShareLinkRequest} The populated <code>ShareLinkRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ShareLinkRequest();
      if (data.hasOwnProperty('to'))
        obj.to = ApiClient.convertToType(data['to'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('resourceType'))
        obj.resourceType = ApiClient.convertToType(data['resourceType'], 'String');
      if (data.hasOwnProperty('urlLink'))
        obj.urlLink = ApiClient.convertToType(data['urlLink'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('permissions'))
        obj.permissions = ApiClient.convertToType(data['permissions'], 'String');
      if (data.hasOwnProperty('sourceId'))
        obj.sourceId = ApiClient.convertToType(data['sourceId'], 'String');
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('snapshotName'))
        obj.snapshotName = ApiClient.convertToType(data['snapshotName'], 'String');
      if (data.hasOwnProperty('snapshotDate'))
        obj.snapshotDate = ApiClient.convertToType(data['snapshotDate'], 'String');
      if (data.hasOwnProperty('all'))
        obj.all = ApiClient.convertToType(data['all'], 'Boolean');
      if (data.hasOwnProperty('dbPerson'))
        obj.dbPerson = Person.constructFromObject(data['dbPerson']);
    }
    return obj;
  }
}

/**
 * @member {String} to
 */
ShareLinkRequest.prototype.to = undefined;

/**
 * @member {String} message
 */
ShareLinkRequest.prototype.message = undefined;

/**
 * @member {String} resourceType
 */
ShareLinkRequest.prototype.resourceType = undefined;

/**
 * @member {String} urlLink
 */
ShareLinkRequest.prototype.urlLink = undefined;

/**
 * @member {String} firstname
 */
ShareLinkRequest.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
ShareLinkRequest.prototype.lastname = undefined;

/**
 * @member {String} password
 */
ShareLinkRequest.prototype.password = undefined;

/**
 * @member {String} permissions
 */
ShareLinkRequest.prototype.permissions = undefined;

/**
 * @member {String} sourceId
 */
ShareLinkRequest.prototype.sourceId = undefined;

/**
 * @member {String} snapshotId
 */
ShareLinkRequest.prototype.snapshotId = undefined;

/**
 * @member {String} snapshotName
 */
ShareLinkRequest.prototype.snapshotName = undefined;

/**
 * @member {String} snapshotDate
 */
ShareLinkRequest.prototype.snapshotDate = undefined;

/**
 * @member {Boolean} all
 */
ShareLinkRequest.prototype.all = undefined;

/**
 * @member {module:model/Person} dbPerson
 */
ShareLinkRequest.prototype.dbPerson = undefined;

